import React, { useState, useEffect } from "react";
import { Row, Col, Button, Form, Dropdown, ButtonGroup } from "react-bootstrap";
import { IoTimeOutline } from "react-icons/io5";
import "./pending-leave.css";
import LeaveLayout from "../../components/LeaveLayout.js";

const rowsPerPage = 10;

export default function PendingLeave() {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch pending leaves for the user
  const fetchPendingLeaves = async () => {
    setLoading(true);
    setError(null);

    try {
      const userId = localStorage.getItem("userId");

      // Validate userId on the frontend
      if (!userId || userId.trim() === "") {
        throw new Error("User ID is missing or invalid. Please log in again.");
      }

      // API call
      const response = await fetch(
        "http://localhost:5544/api/leaves/pending-leaves",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userId, // Send userId in headers
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          `Failed to fetch pending leaves. Status: ${response.status}`
        );
      }

      const result = await response.json();
      setData(result.pendingLeaves || []);
    } catch (error) {
      console.error("Error fetching pending leaves:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingLeaves();
  }, []);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(data.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(data.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <LeaveLayout>
      <div>
        <h1 className="pending-leave-header">
          <IoTimeOutline className="pending-leave-icon" />
          Pending Leaves
        </h1>
        <hr />
        <div className="pending-leave-content">
          <div>
            <div className="entries-search-container" style={{ marginTop: 0 }}>
              <Row>
                <Col xs={12} md={6} className="d-flex align-items-center">
                  <Dropdown as={ButtonGroup}>
                    <Button variant="primary">Show Entries</Button>
                    <Dropdown.Toggle
                      split
                      variant="primary"
                      id="dropdown-split-basic"
                    />
                    <Dropdown.Menu>
                      <Dropdown.Item>10</Dropdown.Item>
                      <Dropdown.Item>25</Dropdown.Item>
                      <Dropdown.Item>50</Dropdown.Item>
                      <Dropdown.Item>100</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
                <Col
                  xs={12}
                  md={6}
                  className="d-flex justify-content-end search-container"
                >
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      className="search-input"
                    />
                  </Form>
                </Col>
              </Row>
            </div>
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr className="pending-leave-table-header">
                    <th>SR</th>
                    <th>Leave Type</th>
                    <th>Days</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="4" className="text-center">
                        Loading...
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="4" className="text-center">
                        {error}
                      </td>
                    </tr>
                  ) : data.length > 0 ? (
                    data
                      .slice(
                        (currentPage - 1) * rowsPerPage,
                        currentPage * rowsPerPage
                      )
                      .map((item, index) => (
                        <tr key={item._id || index}>
                          <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                          <td>{item.leaveType}</td>
                          <td>{item.days}</td>
                          <td>{item.reason}</td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No pending leaves available
                      </td>
                    </tr>
                  )}
                </tbody>
                <tfoot>
                  <tr className="pending-leave-table-footer">
                    <td>Total</td>
                    <td>-</td>
                    <td>{data.length}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
              <div className="containerrrr">
                <Row className="custom-row">
                  <Col xs={12} md={9} className="custom-col-left">
                    Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
                    {Math.min(currentPage * rowsPerPage, data.length)} of{" "}
                    {data.length} Entries
                  </Col>
                  <Col xs={12} md={3} className="custom-col-right">
                    <nav>
                      <ul className="pagination">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <a
                            href="/#"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(currentPage - 1);
                            }}
                          >
                            Previous
                          </a>
                        </li>
                        {pageRange().map((pageNumber) => (
                          <li
                            key={pageNumber}
                            className={`page-item ${
                              currentPage === pageNumber ? "active" : ""
                            }`}
                          >
                            <a
                              href="/#"
                              className="page-link"
                              onClick={(e) => {
                                e.preventDefault();
                                handlePageChange(pageNumber);
                              }}
                            >
                              {pageNumber}
                            </a>
                          </li>
                        ))}
                        <li
                          className={`page-item ${
                            currentPage === Math.ceil(data.length / rowsPerPage)
                              ? "disabled"
                              : ""
                          }`}
                        >
                          <a
                            href="/#"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(currentPage + 1);
                            }}
                          >
                            Next
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LeaveLayout>
  );
}
